import React, { useMemo, useState } from 'react'
import { Table, Input, Modal, Popover } from 'antd'
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { NPersonal, EPostMyInfo, EDelMyInfo, EGetHotSearch } from '../../../../models/constants'
import { effect, useStore, reducer } from '../../../../dva16'
import './index.less'

export default function MyInfo() {
  const { confirm } = Modal
  const [changePage, setChangePage] = useState(1)
  const [status, setStatus] = useState(null)
  const { myInfo } = useStore(NPersonal)
  const [currentInfo, setCurrentInfo] = useState(null)

  useMemo(() => {
    effect(NPersonal, EPostMyInfo)
  }, [])

  function operateInfo(type) {
    console.log('currentInfo', currentInfo)
    if (type === 'detail') {
      window.location.href = `#detail/${currentInfo.id}`
    } else if (type === 'edit') {
      console.log('edit')
    }
  }

  const showDeleteConfirm = (item) => {
    confirm({
      title: `确认删除【${item.title}】`,
      icon: <ExclamationCircleOutlined />,
      content: '一旦删除不可恢复请确认是否删除',
      okText: '确认',
      okType: 'danger',
      cancelText: '取消',
      onOk() {
        effect(NPersonal, EDelMyInfo, { id: item.id, page: changePage, status })
      },
    })
  }

  const handleKeyUp = (e) => {
    if (e.keyCode === 13) {
      effect(NPersonal, EPostMyInfo, { search: e.target.value })
    }
  }
  const content = (
    <div className="operate-wrapper">
      {currentInfo && currentInfo.status === '正常' ? (
        <div className="operate-item">
          <p
            onClick={() => {
              operateInfo('detail')
            }}
          >
            查看详情
          </p>
          {/* <p
            onClick={() => {
              operateInfo('edit')
            }}
          >
            编辑
          </p> */}
        </div>
      ) : (
        <p
        // onClick={() => {
        //   operateInfo('edit')
        // }}
        >
          待审核通过
        </p>
      )}
    </div>
  )
  const TableColumns = [
    {
      title: '帖子',
      dataIndex: 'title',
      width: 250,
      key: 'title',
      render: (text, item) => (
        <Popover trigger="hover" content={content}>
          <span
            style={{ cursor: 'pointer' }}
            onMouseEnter={() => {
              setCurrentInfo(item)
            }}
          >
            {item.topic ? `【${item.topic.name}】${text}` : text}
          </span>
        </Popover>
      ),
    },
    {
      title: '板块',
      dataIndex: 'type',
      key: 'type',
    },
    {
      title: '发布时间',
      dataIndex: 'createdAt',
      key: 'createdAt',
    },
    {
      title: '查看/回复',
      dataIndex: 'num',
      key: 'num',
      render: (text, item) => {
        return <span>{`${item.visitCount}/${item.commentCount}`}</span>
      },
    },
    {
      title: '状态',
      dataIndex: 'status',
      key: 'status',
      render: (text, item) => {
        return text === '回收站' ? (
          <span>{text}</span>
        ) : (
          <span onClick={() => showDeleteConfirm(item)} style={{ cursor: 'pointer' }}>
            {text} <DeleteOutlined />
          </span>
        )
      },
    },
  ]

  return (
    <div id="MyInfo">
      <div className="myinfo-title">
        <div className="title-lfet">
          <span>我的帖子</span>
          <Input onKeyUp={(e) => handleKeyUp(e)} placeholder="搜索帖子" />
        </div>
        <div className="title-center">
          <span
            onClick={() => {
              effect(NPersonal, EPostMyInfo, { status: '正常', page: 1 })
              setStatus('正常')
            }}
          >
            已发布
          </span>
          <span className="line">|</span>
          <span
            onClick={() => {
              setStatus('待审核')
              effect(NPersonal, EPostMyInfo, { status: '待审核', page: 1 })
            }}
          >
            审核中
          </span>
          <span className="line">|</span>
          <span
            onClick={() => {
              setStatus('待修改')
              effect(NPersonal, EPostMyInfo, { status: '待修改', page: 1 })
            }}
          >
            待修改
          </span>
          <span className="line">|</span>
          <span
            onClick={() => {
              setStatus('回收站')
              effect(NPersonal, EPostMyInfo, { status: '回收站', page: 1 })
            }}
          >
            回收站
          </span>
        </div>
        <div className="title-right">
          <span>
            共有<i>{myInfo.total}</i>个帖子
          </span>
        </div>
      </div>
      <Table
        rowKey={(record) => record.id}
        onChange={(pagination, filters, sorter, extra) => {
          setChangePage(pagination.current)
          effect(NPersonal, EPostMyInfo, { page: pagination.current, status })
        }}
        pagination={{ total: myInfo.total }}
        columns={TableColumns}
        dataSource={myInfo.data}
      />
    </div>
  )
}
